import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type CreatorApplication = {
  id: string;
  name: string;
  contact: string;
  social_links: string;
  game_type: string;
  experience: string;
  status: 'pending' | 'approved' | 'rejected';
  created_at: string;
  updated_at: string;
};

export type VideoSubmission = {
  id: string;
  creator_id: string;
  creator_name: string;
  video_title: string;
  video_url: string;
  platform: 'instagram' | 'tiktok' | 'youtube';
  game_type: string;
  description: string;
  status: 'pending' | 'approved' | 'rejected';
  view_count: number;
  reward_amount: number;
  admin_notes: string | null;
  created_at: string;
  updated_at: string;
};

export type CreatorProfile = {
  id: string;
  name: string;
  email: string;
  phone: string | null;
  line_id: string | null;
  social_links: string | null;
  game_type: string | null;
  total_videos: number;
  total_rewards: number;
  bank_name: string | null;
  bank_branch: string | null;
  bank_account_name: string | null;
  bank_account_number: string | null;
  created_at: string;
  updated_at: string;
};

export type ProfileChangeRequest = {
  id: string;
  creator_id: string;
  requested_by: string;
  change_type: string;
  field_name: string;
  old_value: string | null;
  new_value: string | null;
  status: 'pending' | 'confirmed' | 'rejected';
  admin_note: string | null;
  created_at: string;
  confirmed_at: string | null;
  updated_at: string;
};
